// Activities mock data for DemoEdge Activities tab.
// Structured to match the real API response format:
//   timestamp  – Unix ms (number)
//   uuid       – hex hash
//   origin     – UI | DEVICE | IOT_ON | API
//   user_name  – "System" | "Device" | "IoT.ON" | login
//   field      – human-readable label
//   field_path – slash-separated path
//   old_value  – string | null
//   new_value  – string | null
//   targetEdgeControllerId – used for per-controller filtering (not in real API)

export const demoEdgeMockActivities = [
  // ── EC-HW-2024-003-G  Config Update - Peak Hours ───────────────────────────
  {
    uuid: 'a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f60001',
    targetEdgeControllerId: 'EC-HW-2024-003-G',
    timestamp: 1770206400000,
    user_name: 'marko.polo@iotecha.com',
    origin: 'UI',
    field: 'Configuration Backup',
    field_path: 'controller/config_backup',
    old_value: null,
    new_value: 'Backup created successfully.',
  },
  {
    uuid: 'a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f60002',
    targetEdgeControllerId: 'EC-HW-2024-003-G',
    timestamp: 1770381600000,
    user_name: 'Device',
    origin: 'DEVICE',
    field: 'Load Balancing Mode',
    field_path: 'config/load_balancing/mode',
    old_value: 'standard',
    new_value: 'peak_hours',
  },
  {
    uuid: 'a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f60003',
    targetEdgeControllerId: 'EC-HW-2024-003-G',
    timestamp: 1770381660000,
    user_name: 'Device',
    origin: 'DEVICE',
    field: 'Load Balancing Max Load Per Charger',
    field_path: 'config/load_balancing/max_load_per_charger',
    old_value: '32',
    new_value: '75',
  },
  {
    uuid: 'a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f60004',
    targetEdgeControllerId: 'EC-HW-2024-003-G',
    timestamp: 1770381720000,
    user_name: 'Device',
    origin: 'DEVICE',
    field: 'Monitoring Alert Threshold',
    field_path: 'config/monitoring/alert_threshold',
    old_value: '80',
    new_value: '85',
  },
  {
    uuid: 'a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f60005',
    targetEdgeControllerId: 'EC-HW-2024-003-G',
    timestamp: 1770381780000,
    user_name: 'IoT.ON',
    origin: 'IOT_ON',
    field: 'Configuration Validation',
    field_path: 'controller/config_validation',
    old_value: null,
    new_value: 'Configuration validated and services restarted successfully.',
  },
  {
    uuid: 'a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f60006',
    targetEdgeControllerId: 'EC-HW-2024-003-G',
    timestamp: 1770554400000,
    user_name: 'admin@iotecha.com',
    origin: 'UI',
    field: 'Load Balancing Mode',
    field_path: 'config/load_balancing/mode',
    old_value: 'peak_hours',
    new_value: 'off_peak',
  },
  {
    uuid: 'a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f60007',
    targetEdgeControllerId: 'EC-HW-2024-003-G',
    timestamp: 1770727200000,
    user_name: 'Device',
    origin: 'DEVICE',
    field: 'Online',
    field_path: 'controller/changed_online_status',
    old_value: 'Yes',
    new_value: 'No',
  },
  {
    uuid: 'a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f60008',
    targetEdgeControllerId: 'EC-HW-2024-003-G',
    timestamp: 1770728100000,
    user_name: 'Device',
    origin: 'DEVICE',
    field: 'Online',
    field_path: 'controller/changed_online_status',
    old_value: 'No',
    new_value: 'Yes',
  },

  // ── EC-HW-2024-001-A  Firmware Update v5.64.0 ──────────────────────────────
  {
    uuid: 'b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a10001',
    targetEdgeControllerId: 'EC-HW-2024-001-A',
    timestamp: 1770206700000,
    user_name: 'nikita.klima@iotecha.com',
    origin: 'UI',
    field: 'FW Update',
    field_path: 'controller/fw_update',
    old_value: null,
    new_value: 'Firmware update to v5.64.0 initiated.',
  },
  {
    uuid: 'b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a10002',
    targetEdgeControllerId: 'EC-HW-2024-001-A',
    timestamp: 1770207120000,
    user_name: 'Device',
    origin: 'DEVICE',
    field: 'Firmware Version',
    field_path: 'controller/firmware_version',
    old_value: '5.63.1',
    new_value: '5.64.0',
  },
  {
    uuid: 'b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a10003',
    targetEdgeControllerId: 'EC-HW-2024-001-A',
    timestamp: 1770207180000,
    user_name: 'Device',
    origin: 'DEVICE',
    field: 'Online',
    field_path: 'controller/changed_online_status',
    old_value: 'Yes',
    new_value: 'No',
  },
  {
    uuid: 'b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a10004',
    targetEdgeControllerId: 'EC-HW-2024-001-A',
    timestamp: 1770208080000,
    user_name: 'Device',
    origin: 'DEVICE',
    field: 'Online',
    field_path: 'controller/changed_online_status',
    old_value: 'No',
    new_value: 'Yes',
  },
  {
    uuid: 'b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a10005',
    targetEdgeControllerId: 'EC-HW-2024-001-A',
    timestamp: 1770640800000,
    user_name: 'alex.shem@iotecha.com',
    origin: 'UI',
    field: 'Monitoring Telemetry Interval',
    field_path: 'config/monitoring/telemetry_interval',
    old_value: '30',
    new_value: '15',
  },
  {
    uuid: 'b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a10006',
    targetEdgeControllerId: 'EC-HW-2024-001-A',
    timestamp: 1770726000000,
    user_name: 'admin@iotecha.com',
    origin: 'UI',
    field: 'Load Balancing Balance Interval',
    field_path: 'config/load_balancing/balance_interval',
    old_value: '60',
    new_value: '30',
  },
  {
    uuid: 'b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a10007',
    targetEdgeControllerId: 'EC-HW-2024-001-A',
    timestamp: 1770984000000,
    user_name: 'IoT.ON',
    origin: 'IOT_ON',
    field: 'Soft Constraints Sync',
    field_path: 'schedules/soft_constraints',
    old_value: null,
    new_value: 'Synced 5 schedules from cloud.',
  },
  {
    uuid: 'b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a10008',
    targetEdgeControllerId: 'EC-HW-2024-001-A',
    timestamp: 1771076400000,
    user_name: 'IoT.ON',
    origin: 'IOT_ON',
    field: 'Secret Rotation',
    field_path: 'secrets/db_password',
    old_value: null,
    new_value: 'Database password rotated successfully.',
  },

  // ── EC-HW-2024-002-B  Assign to Downtown Hub ───────────────────────────────
  {
    uuid: 'c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b20001',
    targetEdgeControllerId: 'EC-HW-2024-002-B',
    timestamp: 1770292200000,
    user_name: 'dima.lysyi@iotecha.com',
    origin: 'UI',
    field: 'Plaza Assignment',
    field_path: 'controller/plaza_assignment',
    old_value: null,
    new_value: 'Plaza assignment to "Airport Plaza Station" initiated.',
  },
  {
    uuid: 'c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b20002',
    targetEdgeControllerId: 'EC-HW-2024-002-B',
    timestamp: 1770294000000,
    user_name: 'Device',
    origin: 'DEVICE',
    field: 'Plaza Name',
    field_path: 'controller/plaza_name',
    old_value: null,
    new_value: 'Airport Plaza Station',
  },
  {
    uuid: 'c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b20003',
    targetEdgeControllerId: 'EC-HW-2024-002-B',
    timestamp: 1770294600000,
    user_name: 'Device',
    origin: 'DEVICE',
    field: 'Charger Sync',
    field_path: 'controller/charger_sync',
    old_value: '0',
    new_value: '4',
  },
  {
    uuid: 'c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b20004',
    targetEdgeControllerId: 'EC-HW-2024-002-B',
    timestamp: 1770379200000,
    user_name: 'Device',
    origin: 'DEVICE',
    field: 'Online',
    field_path: 'controller/changed_online_status',
    old_value: 'Yes',
    new_value: 'No',
  },
  {
    uuid: 'c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b20005',
    targetEdgeControllerId: 'EC-HW-2024-002-B',
    timestamp: 1770380100000,
    user_name: 'Device',
    origin: 'DEVICE',
    field: 'Online',
    field_path: 'controller/changed_online_status',
    old_value: 'No',
    new_value: 'Yes',
  },
  {
    uuid: 'c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b20006',
    targetEdgeControllerId: 'EC-HW-2024-002-B',
    timestamp: 1770465600000,
    user_name: 'Valentin.mil@iotecha.com',
    origin: 'UI',
    field: 'Monitoring Alert Threshold',
    field_path: 'config/monitoring/alert_threshold',
    old_value: '90',
    new_value: '80',
  },
  {
    uuid: 'c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b20007',
    targetEdgeControllerId: 'EC-HW-2024-002-B',
    timestamp: 1770984000000,
    user_name: 'IoT.ON',
    origin: 'IOT_ON',
    field: 'Soft Constraints Sync',
    field_path: 'schedules/soft_constraints',
    old_value: null,
    new_value: 'Synced 5 schedules from cloud.',
  },
  {
    uuid: 'c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b20008',
    targetEdgeControllerId: 'EC-HW-2024-002-B',
    timestamp: 1771076460000,
    user_name: 'IoT.ON',
    origin: 'IOT_ON',
    field: 'Secret Rotation',
    field_path: 'secrets/db_password',
    old_value: null,
    new_value: 'Database password rotated successfully.',
  },

  // ── EC-HW-2024-004-D  Unassign from Shopping Mall ──────────────────────────
  {
    uuid: 'd4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c30001',
    targetEdgeControllerId: 'EC-HW-2024-004-D',
    timestamp: 1770465600000,
    user_name: 'admin@iotecha.com',
    origin: 'UI',
    field: 'Plaza Unassignment',
    field_path: 'controller/plaza_assignment',
    old_value: null,
    new_value: 'Plaza unassignment from "Shopping Mall Plaza" initiated.',
  },
  {
    uuid: 'd4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c30002',
    targetEdgeControllerId: 'EC-HW-2024-004-D',
    timestamp: 1770465900000,
    user_name: 'System',
    origin: 'DEVICE',
    field: 'Plaza Unassignment',
    field_path: 'controller/plaza_assignment',
    old_value: 'Shopping Mall Plaza',
    new_value: 'Plaza unassignment failed: timeout after 120s.',
  },
  {
    uuid: 'd4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c30003',
    targetEdgeControllerId: 'EC-HW-2024-004-D',
    timestamp: 1770552000000,
    user_name: 'admin@iotecha.com',
    origin: 'UI',
    field: 'Plaza Unassignment',
    field_path: 'controller/plaza_assignment',
    old_value: null,
    new_value: 'Plaza unassignment retry initiated.',
  },
  {
    uuid: 'd4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c30004',
    targetEdgeControllerId: 'EC-HW-2024-004-D',
    timestamp: 1770552180000,
    user_name: 'Device',
    origin: 'DEVICE',
    field: 'Plaza Name',
    field_path: 'controller/plaza_name',
    old_value: 'Shopping Mall Plaza',
    new_value: null,
  },
  {
    uuid: 'd4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c30005',
    targetEdgeControllerId: 'EC-HW-2024-004-D',
    timestamp: 1770552360000,
    user_name: 'Device',
    origin: 'DEVICE',
    field: 'Online',
    field_path: 'controller/changed_online_status',
    old_value: 'Yes',
    new_value: 'No',
  },
  {
    uuid: 'd4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c30006',
    targetEdgeControllerId: 'EC-HW-2024-004-D',
    timestamp: 1770553260000,
    user_name: 'Device',
    origin: 'DEVICE',
    field: 'Online',
    field_path: 'controller/changed_online_status',
    old_value: 'No',
    new_value: 'Yes',
  },
  {
    uuid: 'd4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c30007',
    targetEdgeControllerId: 'EC-HW-2024-004-D',
    timestamp: 1771076520000,
    user_name: 'IoT.ON',
    origin: 'IOT_ON',
    field: 'Secret Rotation',
    field_path: 'secrets/db_password',
    old_value: null,
    new_value: 'Database password rotated successfully.',
  },

  // ── EC-HW-2024-005-E  Handover to Valeo ────────────────────────────────────
  {
    uuid: 'e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d40001',
    targetEdgeControllerId: 'EC-HW-2024-005-E',
    timestamp: 1770292800000,
    user_name: 'vlad.smith@iotecha.com',
    origin: 'UI',
    field: 'Customer Change',
    field_path: 'controller/customer_change',
    old_value: null,
    new_value: 'Customer handover to "Valeo" initiated.',
  },
  {
    uuid: 'e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d40002',
    targetEdgeControllerId: 'EC-HW-2024-005-E',
    timestamp: 1770293100000,
    user_name: 'Device',
    origin: 'DEVICE',
    field: 'Customer Name',
    field_path: 'controller/customer_name',
    old_value: null,
    new_value: 'Valeo',
  },
  {
    uuid: 'e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d40003',
    targetEdgeControllerId: 'EC-HW-2024-005-E',
    timestamp: 1770293400000,
    user_name: 'Device',
    origin: 'DEVICE',
    field: 'Customer Permissions',
    field_path: 'controller/customer_permissions',
    old_value: null,
    new_value: '["read","write","execute"]',
  },
  {
    uuid: 'e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d40004',
    targetEdgeControllerId: 'EC-HW-2024-005-E',
    timestamp: 1770380400000,
    user_name: 'IoT.ON',
    origin: 'IOT_ON',
    field: 'Secret Rotation',
    field_path: 'secrets/db_password',
    old_value: null,
    new_value: 'Database password rotated successfully.',
  },
  {
    uuid: 'e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d40005',
    targetEdgeControllerId: 'EC-HW-2024-005-E',
    timestamp: 1770382200000,
    user_name: 'jane.smithol@iotecha.com',
    origin: 'UI',
    field: 'Load Balancing Max Load Per Charger',
    field_path: 'config/load_balancing/max_load_per_charger',
    old_value: '48',
    new_value: '64',
  },
  {
    uuid: 'e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d40006',
    targetEdgeControllerId: 'EC-HW-2024-005-E',
    timestamp: 1770465600000,
    user_name: 'Device',
    origin: 'DEVICE',
    field: 'Migration Schema Version',
    field_path: 'db/schema_version',
    old_value: '1.9.15',
    new_value: '1.9.16',
  },
  {
    uuid: 'e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d40007',
    targetEdgeControllerId: 'EC-HW-2024-005-E',
    timestamp: 1770641400000,
    user_name: 'IoT.ON',
    origin: 'IOT_ON',
    field: 'Soft Constraints Sync',
    field_path: 'schedules/soft_constraints',
    old_value: null,
    new_value: 'Synced 3 schedules from cloud.',
  },
  {
    uuid: 'e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d40008',
    targetEdgeControllerId: 'EC-HW-2024-005-E',
    timestamp: 1771158000000,
    user_name: 'vladimir.smith@iotecha.com',
    origin: 'API',
    field: 'Customer Permissions',
    field_path: 'controller/customer_permissions',
    old_value: '["read","write","execute"]',
    new_value: '["read","write"]',
  },

  // ── EC-HW-2024-006-Z  Firmware v5.63.5 (Canceled) then v5.64.0 ─────────────
  {
    uuid: 'f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e50001',
    targetEdgeControllerId: 'EC-HW-2024-006-Z',
    timestamp: 1770206400000,
    user_name: 'Egor.brat@iotecha.com',
    origin: 'UI',
    field: 'FW Update',
    field_path: 'controller/fw_update',
    old_value: null,
    new_value: 'FW Update to v5.63.5 was not applied because it was canceled by user.',
  },
  {
    uuid: 'f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e50002',
    targetEdgeControllerId: 'EC-HW-2024-006-Z',
    timestamp: 1770292800000,
    user_name: 'admin@iotecha.com',
    origin: 'UI',
    field: 'FW Update',
    field_path: 'controller/fw_update',
    old_value: null,
    new_value: 'Firmware update to v5.64.0 initiated.',
  },
  {
    uuid: 'f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e50003',
    targetEdgeControllerId: 'EC-HW-2024-006-Z',
    timestamp: 1770293520000,
    user_name: 'Device',
    origin: 'DEVICE',
    field: 'Firmware Version',
    field_path: 'controller/firmware_version',
    old_value: '5.62.8',
    new_value: '5.64.0',
  },
  {
    uuid: 'f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e50004',
    targetEdgeControllerId: 'EC-HW-2024-006-Z',
    timestamp: 1770293580000,
    user_name: 'Device',
    origin: 'DEVICE',
    field: 'Online',
    field_path: 'controller/changed_online_status',
    old_value: 'Yes',
    new_value: 'No',
  },
  {
    uuid: 'f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e50005',
    targetEdgeControllerId: 'EC-HW-2024-006-Z',
    timestamp: 1770294480000,
    user_name: 'Device',
    origin: 'DEVICE',
    field: 'Online',
    field_path: 'controller/changed_online_status',
    old_value: 'No',
    new_value: 'Yes',
  },
];
